import * as moment from 'moment';

export class DateRangeFilterModel {
  private _startDate: Date;
  private _endDate: Date;
  private _fieldDivisionID: string;
  private _cgicCode: string;
  private _duration: number;

  constructor(fieldDivisionId: string, duration: number, startDate?: Date, endDate?: Date) {
    this._startDate = startDate === undefined ? moment().subtract(duration - 1, 'days').toDate() : new Date(startDate);
    this._endDate = endDate === undefined ? new Date(new Date().setHours(23, 59, 59, 999)) : new Date(endDate);
    this._fieldDivisionID = fieldDivisionId;
    this._duration = duration;
  }

  get duration(): number {
    return this._duration;
  }

  set duration(days: number) {
    this._duration = days;
  }

  get startDate(): Date {
    return this._startDate;
  }

  set startDate(dt: Date) {
    this._startDate = dt;
  }

  get endDate(): Date {
    return this._endDate;
  }

  set endDate(dt: Date) {
    this._endDate = dt;
  }

  get fieldDivisionID(): string {
    return this._fieldDivisionID;
  }

  set fieldDivisionID(id: string) {
    this._fieldDivisionID = id;
  }

  get cgicCode(): string {
    return this._cgicCode;
  }

  set cgicCode(id: string) {
    this._cgicCode = id;
  }
}
